/* eslint-disable import/no-extraneous-dependencies */
import { usePickerContext } from '@mui/x-date-pickers/hooks'
import { useTranslation } from 'react-i18next'
import Button from '../Button/Button'
import styles from './TimePickerActionBar.module.scss'

interface TimePickerActionBarProps {
  /** The layout's own class, it places the bar in the popup's grid. */
  className?: string
}

/**
 * Replaces MUI's action bar so the two buttons are the app's own, same fill,
 * same condensed label, and no ripple, which the stock `Button` brings with it.
 *
 * The bar exists because a time picker has two steps: MUI keeps the popup open
 * after the hour is chosen, so something has to confirm the pair.
 */
function TimePickerActionBar({ className }: TimePickerActionBarProps) {
  const { acceptValueChanges, cancelValueChanges } = usePickerContext()
  const { t } = useTranslation()

  return (
    <div className={`${className ?? ''} ${styles.actionBar}`}>
      <Button
        variant="contained"
        color="secondary"
        label={t('COMMON.CANCEL')}
        onClick={cancelValueChanges}
      />
      <Button
        variant="contained"
        color="primary"
        label={t('COMMON.OK')}
        onClick={acceptValueChanges}
      />
    </div>
  )
}

export default TimePickerActionBar
